import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getEnvUrl, getToken } from "../../../utils/Api";
import CreateEditTvApk from "./popups/createTvApk";
import ViewTvApk from "./popups/viewTvApk";
import Loader from "../../common/loader";
import { toast } from "react-toastify";
import { deleteTvApkByID, getTvApkProjectByID } from "../../../Services/TvApksService/TvApkService";
import { checkPermissions } from "../../../Services/User/User";

const $ = require("jquery");
require("datatables.net");

const ProjectTvApkPage = () => {
  const tableRef = useRef(null);

  const navigate = useNavigate();
  const { projectId } = useParams();

  const [isLoading, setIsLoading] = useState(true);

  const [tvApkModal, setTvApkModal] = useState(false);
  const [viewTvApkModal, setViewTvApkModal] = useState(false);
  const [editTvApkModal, setEditTvApkModal] = useState(false);

  const [viewTvApkId, setViewTvApkId] = useState(null);
  const [editTvApkId, setEditTvApkId] = useState(null);
  const [projectName, setProjectName] = useState(null);

  const [rerender, setRerender] = useState(false);

  const createPopupClose = (refresh = true) => {
    setTvApkModal(false);

    if (refresh) {
      setRerender(!rerender);
    }
  };

  const editPopupClose = (refresh = true) => {
    setEditTvApkModal(false);

    if (refresh) {
      setRerender(!rerender);
    }
  };

  const viewPopupClose = () => {
    setViewTvApkModal(false);
  };

  useEffect(() => {
    if (
      !checkPermissions("subject_page") ||
      !checkPermissions("games_navigation")
    ) {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    fetchTvApkProjectDetails();
  }, []);
  const fetchTvApkProjectDetails = async () => {
    try {
      const response = await getTvApkProjectByID(projectId);
      if (response?.status) {
        setProjectName(response.data.name || "");
      } else {
        toast.error("Failed to fetch tvapk details");
      }
    } catch (error) {
      console.error("Error fetching tvapk details:", error);
    }
  };
  useEffect(() => {
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",

      ajax: {
        url: `${getEnvUrl()}/admin/tvapk/getTvApkList?projectId=${projectId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },

      columns: [
        { data: "id" },
        { data: "name" },
        // {
        //   data: "active",
        //   render: (data, type) => {
        //     const isActive =
        //       data === true ||
        //       data === 1 ||
        //       data === "true" ||
        //       data === "1";
        //     const label = isActive ? "Active" : "In Active";
        //     if (type === "display") {
        //       return isActive
        //         ? `<span style="
        //             display:inline-block;
        //             padding:3px 10px;
        //             border-radius:20px;
        //             font-size:12px;
        //             font-weight:600;
        //             background:#dcfce7;
        //             color:#16a34a;
        //             border:1px solid #bbf7d0;
        //           ">Active</span>`
        //         : `<span style="
        //             display:inline-block;
        //             padding:3px 10px;
        //             border-radius:20px;
        //             font-size:12px;
        //             font-weight:600;
        //             background:#fee2e2;
        //             color:#dc2626;
        //             border:1px solid #fecaca;
        //           ">In Active</span>`;
        //     }
        //     return label;
        //   },
        // },
        {
          data: null,
          title: "Actions",
          render: (data, type, row) => {
            const isActive = row.active === true || row.active === 1 || row.active === "true" || row.active === "1";
            const toggleIcon = isActive
              ? `<i class="bi bi-toggle-on" style="font-size:20px;color:#16a34a;"></i>`
              : `<i class="bi bi-toggle-off" style="font-size:20px;color:#dc2626;"></i>`;
            const toggleTitle = isActive ? "Click to Deactivate" : "Click to Activate";
            return `
              <div style="display:flex;align-items:center;gap:10px;">
                  <span class="a-manage" title="Manage" style="cursor:pointer;">
                      <i class="bi bi-gear-fill"></i>
                  </span>


              </div>
            `;
          },
        },
      ],
  //                 < span class= "a-edit" title = "Edit" style = "cursor:pointer;" >
  //   <i class="bi bi-pencil-square"></i>
  //                 </span >

  // <span class="a-toggle" title="${toggleTitle}" style="cursor:pointer;line-height:1;">
  //   ${toggleIcon}
  // </span>
      columnDefs: [
        {
          targets: [2],
          orderable: false,
        },
      ],

      createdRow: (row, data) => {
        if (!checkPermissions("subject_edit")) {
          $(row).find(".a-edit").remove();
        }

        if (!checkPermissions("subject_delete")) {
          $(row).find(".a-toggle").remove();
        }

        $(row)
          .find(".a-manage")
          .on("click", () => {
            navigate(`/tvapk/manage/${projectId}/${data.id}`);
          });

        $(row)
          .find(".a-edit")
          .on("click", () => {
            setEditTvApkId(data.id);
            setEditTvApkModal(true);
          });

        $(row)
          .find(".a-toggle")
          .on("click", () => {
            const isActive = data.active === true || data.active === 1 || data.active === "true" || data.active === "1";
            const action = isActive ? "deactivate" : "activate";
            if (window.confirm(`Are you sure you want to ${action} this TV APK?`)) {
              deleteTvApkByID(data.id, !isActive)
                .then((response) => {
                  if (response && response.status) {
                    toast.success(response.message || `TV APK ${action}d successfully.`);
                    setRerender((prev) => !prev);
                  } else {
                    toast.error((response && response.errorMessage) || `Failed to ${action} TV APK.`);
                  }
                })
                .catch(() => {
                  toast.error(`Error trying to ${action} TV APK.`);
                });
            }
          });
      },

      drawCallback: () => {
        setIsLoading(false);
      },

      aaSorting: [[0, "desc"]],
    });

    return () => table.destroy();
  }, [projectId, rerender]);

  return (
    <div>
      <main id="main" className="main">

        <div className="pagetitle">
          <h1>TV APKs</h1>

          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/masters/tvApkProjects");
                  }}
                >
                  Projects
                </a>
              </li>

              <li className="breadcrumb-item active">
                Project #{projectId} - {projectName}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">

              <div className="card">

                <div className="card-title d-flex justify-content-between px-3">

                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate("/masters/tvApkProjects")}
                  >
                    ← Back
                  </button>

                  {checkPermissions("subject_create") && (
                    <button
                      className="btn btn-primary"
                      onClick={() => setTvApkModal(true)}
                    >
                      + Add TV APK
                    </button>
                  )}

                </div>

                {isLoading && <Loader />}

                <div className={isLoading ? "card-body hide" : "card-body"}>

                  <table
                    ref={tableRef}
                    width="100%"
                    className="table table-striped table-hover table-bordered"
                  >
                    <thead>
                      <tr>
                        <th>TV APK ID</th>
                        <th>Name</th>
                        {/* <th>Active</th> */}
                        <th>Action</th>
                      </tr>
                    </thead>
                  </table>

                </div>

              </div>

            </div>
          </div>
        </section>
      </main>

      {tvApkModal && (
        <CreateEditTvApk
          isShow={tvApkModal}
          close={createPopupClose}
          type="CREATE"
          projectId={projectId}
        />
      )}

      {viewTvApkModal && (
        <ViewTvApk
          isShow={viewTvApkModal}
          tvApkId={viewTvApkId}
          close={viewPopupClose}
        />
      )}

      {editTvApkModal && (
        <CreateEditTvApk
          isShow={editTvApkModal}
          close={editPopupClose}
          tvApkId={editTvApkId}
          projectId={projectId}
          type="EDIT"
        />
      )}
    </div>
  );
};

export default ProjectTvApkPage;